import { includes } from 'lodash';
var BaseModel = /** @class */ (function () {
    function BaseModel(data) {
        this.id = data.id;
        this.name = data.name;
        this.hydrationStrategy = data.hydrationStrategy || 'hydrate';
        this.isHydrated = false;
    }
    BaseModel.prototype.modelMethodNotFound = function (name, obj) {
        var regex = /\w*Model/g;
        if (obj) {
            var modelMatch = regex.exec(obj.toString());
            var model = modelMatch.pop();
            if (model !== null) {
                console.warn("no " + name + " method available for " + model);
                return;
            }
        }
        console.error("method " + name + " not found on unknown model");
    };
    BaseModel.inDevelopmentEnvironment = function () {
        var _location = window.location;
        var origin = _location.origin;
        return includes(origin, 'localhost');
    };
    BaseModel.validType = function (data, expectedType) {
        if (typeof data !== expectedType) {
            if (BaseModel.inDevelopmentEnvironment()) {
                console.warn(data + " is not expected type " + expectedType);
            }
            return false;
        }
        return true;
    };
    BaseModel.prototype.convertBool = function (value) {
        if (typeof value === 'undefined') {
            return false;
        }
        if (value === 'false' || +value === 0) {
            return false;
        }
        return value;
    };
    BaseModel.prototype.convertInt = function (value, defaultValue) {
        if (defaultValue === void 0) { defaultValue = 0; }
        if (typeof value === 'undefined' || value === null) {
            return defaultValue;
        }
        if (value === '0') {
            return 0;
        }
        return +value;
    };
    BaseModel.prototype.hydrate = function (data) {
        this.modelMethodNotFound('hydrate', this);
        return {};
    };
    BaseModel.prototype.export = function (data) {
        this.modelMethodNotFound('export', this);
        return {};
    };
    BaseModel.prototype.useHydrator = function (data) {
        // This `isHydrated` check was added to prevent double-hydration since un-hydrated items
        // use snake_case while hydrated item use camelCase. If you pass in an already-hydrated item
        // you will end up with the defaults/fallbacks for all properties that have more than 1 word
        // in them (eg: `hydrated.firstName = input.first_name || '';`). Now we check if it's already
        // be hydrated and then set `isHydrated` on the class itself to true and return the data so that
        // each class can set the hydrated data onto itself. Likewise, at the bottom of this function we set
        // `isHydrated` to true. We might look into changing this to a simple `data instanceOf BaseModel` but
        // for now this is the fix we went with.
        if (data.isHydrated) {
            this.isHydrated = true;
            return data;
        }
        var functionName = this.hydrationStrategy;
        // @ts-ignore
        var hydrateFunction = this[functionName];
        var result = hydrateFunction(data);
        this.isHydrated = true;
        return result;
    };
    BaseModel.prototype.printDebug = function () {
        var statement = '';
        for (var prop in this) {
            statement += prop + " - " + this[prop];
        }
        return statement;
    };
    return BaseModel;
}());
export default BaseModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/BaseModel.ts
// module id = z2Tw
// module chunks = 18